export default __webpack_public_path__ + "static/media/apple-button.466b9767.png";